import SoundEffect from "./SoundEffect";

export default class SoundEffectManager {
    constructor() {

    }

    /**
     * @param {SoundEffect} soundEffect 
     */
    playSound(soundEffect) {
        if (!soundEffect) {
            return;
        }

        // TODO SoundEffectManager is not implemented!!!!

        // There are lots of cases where we do not want to play a sound.
        // if (soundEffect == null                                              // No sound event specified.
        //         || !state.gameVisible                                       // The game is not visible
        //         || !state.gameSettings.isSoundEffectsEnabled()              // Sound effects are disabled.
        //         || state.gamePaused                                         // The game is paused
        //         || state.viewState.isPowerSaveActive()
        //         || state.advertisementController.isVideoPlaying()) {        // A video is playing
        //     return;
        // }

        // Throttle the number of sounds being played at any one time.
        // if (soundsPlayedThisTurnIndex >= soundsPlayedThisTurn.length) {
        //     return;
        // }

        // // Lots of sound events do not have any sounds effects associated with them. Skip those.
        // final SoundEffect soundEffect = soundEffect.getSoundEffect();
        // if (soundEffect == null) {
        //     return;
        // }

        // const soundPath = soundEffect.getRandomSoundPath();
        // if (!soundPath) {
        //     return;
        // }

        // // Do not play a sound more than once per turn.
        // if (this.isSoundPathPlayedThisTurn(soundPath)) {
        //     return;
        // }

        // Sound sound = soundByPath.get(soundPath);
        // if (sound != null) {
        //     soundsPlayedThisTurn[soundsPlayedThisTurnIndex] = soundPath;
        //     soundsPlayedThisTurnIndex++;

        //     playSoundInternal(soundEffect, sound);
        // }
    }
}